import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.orderHistory || initialState;

export const selectOrders = createSelector(
  [selectDomain],
  (state) => state.orders
);

export const selectLoading = createSelector([selectDomain], (state) => state.loading);

export const selectOrderCount = createSelector(
  [selectDomain],
  (state) => state.orderCount
);
